import { DocumentClass } from './../../../models/business/BusinessClasses'

export default {
  state: {
    document: DocumentClass.getEmptyDocument()
  }
}
